<div class="boxContent">
    <h3>Angular container with upgraded Angularjs component</h3>
    <ng1-upgraded-angular-js 
        [inputParam]="exampleParam"
        (outputParam)="onCountClick($event)">
    </ng1-upgraded-angular-js>
    <h2 *ngIf="count && count > 0">AngularJs component button clicked {{count}} times</h2>
</div>